import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "../../../styles/cards_feriados.css";

import { withNamespaces } from 'react-i18next';

const SliderFeriados = ({ t }) => {
  const optionsObj = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: false,
    navText: [
      "<i class='fas fa-chevron-circle-left'></i>",
      "<i class='fas fa-chevron-circle-right'></i>",
    ],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  };

  const [options, setOptions] = useState(optionsObj);
  useEffect(
    () => {
      setOptions(optionsObj);
    },
    [t]
  );

  return (
    <section className="container feriados">
      <OwlCarousel className="owl-theme" {...options}>
        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card1.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card1.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card1.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia"> {t('moduleCidadeAveiro:S3.Card2.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card2.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card2.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card3.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card3.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card3.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card4.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card4.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card4.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card5.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card5.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card5.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card6.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card6.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card6.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card7.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card7.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card7.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card8.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card8.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card8.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card9.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card9.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card9.P2')}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div className="card feriados">
            <div className="card-body feriados text-center">
              <h3 className="card-title feriados dia">{t('moduleCidadeAveiro:S3.Card10.P1')}</h3>
              <h3 className="card-title feriados">{t('moduleCidadeAveiro:S3.Card10.T')}</h3>
              <p className="card-text feriados">
                {t('moduleCidadeAveiro:S3.Card10.P2')}
              </p>
            </div>
          </div>
        </div>
      </OwlCarousel>
    </section>
  );
};

export default withNamespaces()(SliderFeriados);
